<template>
    <BasePanel
        headline='lang_GENERIC_AZ_PANEL_CAPTION_METADATA'
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-row class="pt-4">
                <v-col cols="4">
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getLanguage"
                            :label="$t('lang_GENERIC_CAPTION_LANGUAGE')"
                            :alvqa="alvqa + '-language'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getFoundingDate"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOUNDING_DATE')"
                            :alvqa="alvqa + '-founding-date'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getCustomerNumber"
                            :label="$t('lang_GENERIC_AZ_CAPTION_CUSTOMER_NUMBER')"
                            :alvqa="alvqa + '-customer-number'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getCurrency"
                            :label="$t('lang_GENERIC_CAPTION_CURRENCY')"
                            :alvqa="alvqa + '-currency'"
                        />
                    </v-row>
                </v-col>

                <v-col cols="4">
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getTasFromPricelist"
                            :label="$t('lang_AZ_GROUPS_CAPTION_TAS_FROM_PRICELIST')"
                            :alvqa="alvqa + '-tas-from-pricelist'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getWarehouseName"
                            :label="$t('lang_AZ_GROUPS_CAPTION_WAREHOUSE_NAME')"
                            :alvqa="alvqa + '-warehouse-name'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getFocFirstShipment"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOC_FIRST_SHIPMENT')"
                            :alvqa="alvqa + '-foc-first-shipment'"
                            suffix="%"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getFocAllShipments"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOC_ALL_SHIPMENTS')"
                            :alvqa="alvqa + '-foc-all-shipments'"
                            suffix="%"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getHandlingFee"
                            :label="$t('lang_AZ_GROUPS_CAPTION_HANDLING_FEE')"
                            :alvqa="alvqa + '-handling-fee'"
                        />
                    </v-row>
                </v-col>

                <v-col cols="4">
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getDistributorReturnFee"
                            :label="$t('lang_AZ_DISTRIBUTORS_FEE_FOR_RETURNS')"
                            :alvqa="alvqa + '-distributor-return-fee'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getReturnReserveCycle"
                            :label="$t('lang_AZ_DISTRIBUTORS_CYCLE_OF_RETURN_RESERVE')"
                            :alvqa="alvqa + '-return-reserve-cycle'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getReturnReservePercent"
                            :label="$t('lang_AZ_DISTRIBUTORS_CAPTION_RETURNS_RESERVE_PERCENT')"
                            :alvqa="alvqa + '-return-reserve-percent'"
                            suffix="%"
                        />
                    </v-row>
                </v-col>
            </v-row>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'

import 
    { 
        DropdownGenericYesNo,
        DropdownCurrencies,
        DropdownContractsLabelReturnReserveCycle
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "AzDistributorsMetadataReadOnlyPanel",
    components: {
        BasePanel,
        BaseReadOnlyTextField
    },
    data() {
        return {
            alvqa: "az-distributors-readonly-panel-metadata"
        }
    },
    computed: {
        item() { return this.$store.getters.getExpandedAzDistributors },
        getLanguage() {
            let language = this.$store.getters.getAzDistributorsMetadataDetailsLanguage
            return this.$alvPlugin.getTranslatedLanguageName(language)
        },
        getFoundingDate() {
            let date = this.$store.getters.getAzDistributorsMetadataDetailsFoundingDate
            return date ? this.$d(new Date(date), 'alvDateFormat') : ''
        },
        getCustomerNumber() { return this.$store.getters.getAzDistributorsMetadataDetailsCustomerNumber },
        getWarehouseName() { return this.$store.getters.getAzDistributorsMetadataDetailsWarehouseName },
        getFocFirstShipment() { return this.$store.getters.getAzDistributorsMetadataDetailsFocFirstShipment },
        getFocAllShipments() { return this.$store.getters.getAzDistributorsMetadataDetailsFocAllShipments },
        getHandlingFee() { return this.$store.getters.getAzDistributorsMetadataDetailsHandlingFee },
        getDistributorReturnFee() { return this.$store.getters.getAzDistributorsMetadataDetailsDistributorReturnFee },
        getReturnReservePercent() { return this.$store.getters.getAzDistributorsMetadataDetailsReturnReservePercent },
        getReturnReserveCycle() {
            let value = this.$store.getters.getAzDistributorsMetadataDetailsReturnReserveCycle
            let result = DropdownContractsLabelReturnReserveCycle.find(element => {
                return element.value === value
            })

            if(result !== null && result !== undefined) return this.$t(result.text)
            else return null
        },
        getCurrency() {
            let value = this.$store.getters.getAzDistributorsMetadataDetailsCurrency
            let result = DropdownCurrencies.find(element => {
                return element.value === value
            })

            if(result !== null && result !== undefined) return result.text
            else return null
        },
        getTasFromPricelist() { 
            let value = this.$store.getters.getAzDistributorsMetadataDetailsTasFromPricelist 
            let result = DropdownGenericYesNo.find(element => {
                return element.value === value
            })

            if(result !== null && result !== undefined) return this.$t(result.text)
            else return null
        },

        // dropdownLanguages()     { return DropdownErpInvoicesLanguages },
        // dropdownYesNo()         { return DropdownGenericYesNo },
        // dropdownReturnReserveCycle() { return DropdownContractsLabelReturnReserveCycle }
    }
}
</script>